import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
} from '@app/shared';

@Injectable()
export class DynamicFormsFormService {

  constructor() { }

  /**
   * Retorna los controles para crear un nuevo formulario pestaña
   *
   * @param {*} templates
   * @param {*} optios
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof DynamicFormsFormService
   */
  getControlsNewForm(templates: any, optios: any, data?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtNombreFormulario',
        label: 'Nombre formualario:',
        value: data ? data.label : null,
        order: 1,
        placeholder: 'Nombre del formulario',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'txtAlias',
        label: 'Alias del formualario:',
        value: data ? data.alias : null,
        order: 2,
        placeholder: 'Alias del formualario:',
        validations: {
          validators: [Validators.required, Validators.pattern('^[a-zA-Z_]*$')],
          messages: {pattern: 'Caracteres invalidos: solo letras y guiones bajos'}
        }
      }),
      new Custom({
        key: 'cboColumnaRelacion',
        label: 'Columna de relación:',
        placeholder: 'Seleccione la columna con la cual se relaciona la pestaña con el formulario principal',
        value: data ? data.column : null,
        template: templates['ngSelect'],
        options: optios['columns'],
        order: 3,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'cboValorRelacion',
        label: 'Opción:',
        placeholder: 'Seleccione la opcion de la columna por la cual se relaciona la pestaña',
        value: data ? data.valorRelacion : null,
        template: templates['ngSelect'],
        options: optios['optColumnMaster'] ? optios['optColumnMaster'] : [],
        order: 4,
        validations: {
          validators: [Validators.required]
        }
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/dynamic-forms/shared/dynamic-forms.form.service.ts